import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {EnrichedDataRow} from "../../../../lib/bean/EnrichedDataRow";
import {Chart} from "angular-highcharts";
import {ViewerParameters} from '../../../../lib/bean/ViewerParameters';

@Component({
  selector: 'app-viewer-graphs',
  templateUrl: './viewer-graphs.component.html',
  styleUrls: ['./viewer-graphs.component.scss']
})
export class ViewerGraphsComponent implements OnInit, OnChanges {

  @Input()
  enrichedData: EnrichedDataRow[];

  @Input()
  parameters: ViewerParameters;

  columnsToDisplay = ['timeSinceJ2000'];

  earthMarsDistanceChart: Chart = new Chart({
    chart: {
      type: 'line',
      plotBorderWidth: 1,
      height: '100%'
    },
    title: {
      text: 'Distance Terre-Mars'
    },
    legend: {
      enabled: false
    },
    credits: {
      enabled: false
    },
    yAxis: {
      title: {
        text: 'Distance (m)'
      },
      labels: {
        formatter: function() {
          return this.value.toExponential(1);
        }
      }
    },
    series: [
      {
        name: '',
        data: []
      }
    ]
  } as any);

  earthMarsPositionChart: Chart = new Chart({
    chart: {
      type: 'scatter',
      plotBorderWidth: 1,
      zoomType: 'xy',
      height: '100%',
    },
    title: {
      text: 'Position Terre-Mars'
    },
    yAxis: {
      labels: {
        formatter: function() {
          return this.value.toExponential(1);
        }
      }
    },
    credits: {
      enabled: false
    },
    series: [
      {
        name: 'Terre',
        color: 'lightblue',
        data: []
      },
      {
        name: 'Mars',
        color: 'red',
        data: []
      },
      {
        name: 'Soleil',
        color: '#dfdf00',
        symbol: 'circle',
        data: [[0, 0]]
      }
    ]
  } as any);

  constructor() {
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {

    if (this.enrichedData == undefined)
      return;

    this.earthMarsDistanceChart.ref.series[0].setData(this.enrichedData
      .filter((entry, index) => index < 800)
      .map((entry, index) => {
        return {
          y: entry.earthMarsDistance,
          marker: {
            symbol: 'url(https://www.highcharts.com/samples/graphics/sun.png)',
            enabled: index + 1 == this.parameters.observationDay
          }
        };
    }));

    this.earthMarsPositionChart.ref.series[0].setData(this.enrichedData
      .filter((entry, index) => index < 40)
      .map((entry, index) => [entry.earthPositionX, entry.earthPositionY]));

    this.earthMarsPositionChart.ref.series[1].setData(this.enrichedData
      .filter((entry, index) => index < 40)
      .map((entry, index) => [entry.marsPositionX, entry.marsPositionY]));
  }


}
